import resume from '../assets/pdf/Md_Shahbaz.pdf'
// import img from '../my image12.jpg'

// D:\d drive downloads\Personal_Portfolio-main\Personal_Portfolio-main\src\my image12.jpg

export const headerData = {
    name: 'Md Shahbaz Alam',
    title: "Full Stack Web Developer",
    desciption: 'There is no such thing as a boring project. There are only boring executions.',
    image: 'https://ca.slack-edge.com/T02KMNEUZ43-U03BJHAGD16-f76d563c2090-512',
    resumePdf: resume
}

// https://ca.slack-edge.com/T02KMNEUZ43-U03BJHAGD16-5da7006992a8-512
{/* <img src="https://i.ibb.co/s1SXpxy/1658902087678.jpg" alt="1658902087678" border="0"> */}